import { useState } from "react";
import { getCurrencySymbol, setCurrencySymbol } from "src/utils/currency";

const OPTIONS = [
  { label: "EUR — €", value: "€" },
  { label: "GBP — £", value: "£" },
];

export function SetCurrencySymbolScreen() {
  const [current, setCurrent] = useState(getCurrencySymbol);

  function handleChange(value: string) {
    setCurrent(value);
    setCurrencySymbol(value);
  }

  return (
    <div className="flex w-full h-screen items-center justify-center bg-gray-100">
      <div className="bg-white rounded shadow p-8 w-[360px] space-y-6">
        <h1 className="text-xl font-semibold text-neutral-8">Currency Symbol</h1>
        <p className="text-sm text-neutral-6">
          Override the currency symbol shown throughout the app. The underlying cost data is
          unchanged — this is for demo purposes only.
        </p>
        <div className="space-y-2">
          <label className="block text-sm font-medium text-neutral-7">Currency</label>
          <select
            value={current}
            onChange={(e) => handleChange(e.target.value)}
            className="w-full border border-neutral-3 rounded px-3 py-2 text-sm text-neutral-8 bg-white"
          >
            {OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <p className="text-xs text-neutral-5">
          Stored in localStorage. Changes take effect immediately across all open tabs.
        </p>
      </div>
    </div>
  );
}
